import type { MergePreviewResult } from 'apis/master-product-families';

// Pure preview -> display-string mapper for the merge modal, kept separate
// from the component so the pluralization branch is unit-testable without
// mounting a Modal + async-select tree. Merge is move-only — there is no
// collision/collapse reporting anymore.
export interface MergeSummary {
  movedLine: string;
}

export function buildMergeSummary(preview: MergePreviewResult, targetName: string): MergeSummary {
  const { moved } = preview;

  return { movedLine: `${moved} variant${moved === 1 ? '' : 's'} will move to ${targetName}` };
}
